import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StartPageComponent } from './start-page/start-page.component';
import { UserDetailsComponent } from './user-details/user-details.component';
import { CycleDetailsComponent } from './cycle-details/cycle-details.component';
import { UserMoreDetailsComponent } from './user-more-details/user-more-details.component';

import { MashkantaQuestionerComponent } from './mashkanta-questioner/mashkanta-questioner.component';
import { BorrowersDetailsComponent } from './borrowers-details/borrowers-details.component';
import { FinancingSourcesComponent } from './financing-sources/financing-sources.component';
import { LiabilitiesComponent } from './liabilities/liabilities.component';
import { CanProceedGuard } from './can-proceed.guard';
import { SummarizePageComponent } from './summarize-page/summarize-page.component';
import { EndPageComponent } from './end-page/end-page.component';
import { AdvisorsComponent } from './advisors/advisors.component';


const routes: Routes = [
	{
		path: '',
		component: StartPageComponent,
		data: { title: 'טופס משכנתא' }
	},

	{
		path: 'questionnaire',
		component: MashkantaQuestionerComponent,
		canActivateChild: [CanProceedGuard],

		children: [
			{
				path:'advisors/:qid',
				component: AdvisorsComponent
			},
			{
				path: 'user-details/:qid',
				component: UserDetailsComponent
			},
			{
				path: 'user-details/:qid',
				component: UserDetailsComponent
			},
			{
				path: 'cycle-details/:qid',
				component: CycleDetailsComponent
			},
			{
				path: 'user-more-details/:qid',
				component: UserMoreDetailsComponent
			},

			{
				path: 'borrowers-details/:qid',
				component: BorrowersDetailsComponent
			},
			{
				path: 'financing-sources/:qid',
				component: FinancingSourcesComponent
			},
			{
				path: 'liabilities/:qid',
				component: LiabilitiesComponent
			},
		]
	},

	{
		path:'summarize',
		component: SummarizePageComponent
	},
	{
		path:'end',
		component: EndPageComponent
	}

];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts